// Start of prototype modal
// --------------------
// @author: Han Speerstra

myConfirm.fn = myConfirm.prototype;

export default function myConfirm($config)
{
	this.id = $config.id || '';
	this.confirm = $config.confirm || '';
	this.deny = $config.deny || '';

	this.confirm_callback = $config.confirm_callback || function () {};
	this.deny_callback = $config.deny_callback || function () {};

	this.title = $config.title || 'Test';
	this.description = $config.description || '';
}

myConfirm.fn.show = function () {
	var that = this;

	var html = '<div class="modal fade" id="' + this.id + 'Confirm">' +
		  '<div class="modal-dialog modal-lg">' +
		    '<div class="modal-content">' +
		      '<div class="modal-header">' +
		        '<h4 class="modal-title">' + this.title + '</h4>' +
                '<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>' +
		      '</div>' +
		      '<div class="modal-body">' +
		        '<p>' + this.description + '</p>' +
		      '</div>' +
		      '<div class="modal-footer">';

		      if(this.deny.length > 0) {
		      html = html +
		        '<button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">' + this.deny + '</button>';
		      }
		      if(this.confirm.length > 0) {
		      html = html +
		        '<button type="button" class="btn btn-success" data-type="confirm">' + this.confirm + '</button>';
		      }
		      html = html +
		      '</div>' +
		    '</div><!-- /.modal-content -->' +
		  '</div><!-- /.modal-dialog -->' +
		'</div><!-- /.modal -->';

	$(html).appendTo($('body'));

	$(document.body)
		.find('#' + this.id + 'Confirm')
			.modal('show')
			.on('hide.bs.modal', function () {
				that.deny_callback();
			})
		.end()
		.on('click', '#' + that.id + 'Confirm [data-type="confirm"]', function () {
			that.confirm_callback(that);

			// destroy the confirmation
		});
}

myConfirm.fn.hide = function () {
	$(document.body)
		.find('#' + this.id + 'Confirm')
			.modal('hide')
}
